import React from 'react';

export const FlexColumn = ({ children }) => {
  return(
    <div className="flex-column">
      { children }
    </div>
  );
};
